import { Subscription } from 'rxjs';
import { VideoSection } from '@kinomap-dev/ng-ui-lib';

export class MapState {
  videos: VideoSection[] = [];
  totalAvailableVideos: number = 0;
  isLoading: boolean = false;
  areVideosComplete: boolean = false;
  requestSubscription?: Subscription;
}
